export default __webpack_public_path__ + "static/media/huskLogo.88b7bf5d.png";